import React, { createContext, useContext, useState } from "react";

const LogContext = createContext();

export const useLog = () => useContext(LogContext);

export const LogProvider = ({ children }) => {
  const [log, setLog] = useState("");
  // console.log()
  //   alert("ddfgdfgdg");
  const appendLog = (newLog) => {
    console.log("newlog12=", newLog);
    setLog((prevLog) => `${prevLog}${newLog}\n`);
  };

  const formatDate = (date) => {
    return new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    }).format(date);
  };

  const logApiRequest = (request, response, startTime, endTime) => {
    const elapsedTime = endTime - startTime;
    const logEntry = `[${formatDate(startTime)}] ${request.method} ${
      request.url
    }\nElapsed Time: ${elapsedTime}ms\nStatus Code: ${response.status}\n`;
    appendLog(logEntry);
  };
  console.log("finallog=", log);
  const downloadLog = () => {
    const blob = new Blob([log], { type: "text/plain" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Apilog.txt";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <LogContext.Provider value={{ log, logApiRequest, downloadLog }}>
      {children}
    </LogContext.Provider>
  );
};
